"use strict";

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProgressMonitor_1 = require("./ProgressMonitor");
/**
 * Serves as aggregation of given progress monitors - in a nutshell:
 *
 * - total = sum of total of monitors
 * - worked = sum of worked of monitors
 * - failed = if any monitor failed
 * - done = if all monitor finished
 *
 * @author Jan Prokop
 */


var AggregatedProgressMonitor =
/*#__PURE__*/
function (_ProgressMonitor_1$Pr) {
  _inherits(AggregatedProgressMonitor, _ProgressMonitor_1$Pr);

  function AggregatedProgressMonitor(monitors) {
    var _this;

    _classCallCheck(this, AggregatedProgressMonitor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AggregatedProgressMonitor).call(this));
    _this.monitors = monitors;
    return _this;
  }

  _createClass(AggregatedProgressMonitor, [{
    key: "wasCanceled",
    value: function () {
      var _wasCanceled = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(this.monitors.map(function (monitor) {
                  return monitor.wasCanceled();
                }));

              case 2:
                res = _context.sent;
                return _context.abrupt("return", res.some(function (canceled) {
                  return canceled;
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function wasCanceled() {
        return _wasCanceled.apply(this, arguments);
      };
    }()
  }, {
    key: "progress",
    value: function progress(amount) {
      throw new Error('It is not possible to mark progress to AggregatedProgressMonitor.'); // or fail silently?
    }
  }, {
    key: "init",
    value: function init(total) {
      throw new Error('It is not possible to initialize AggregatedProgressMonitor.'); // or fail silently?
    }
  }, {
    key: "confirmCanceled",
    value: function () {
      var _confirmCanceled = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(this.monitors.map(function (monitor) {
                  return monitor.confirmCanceled();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function confirmCanceled() {
        return _confirmCanceled.apply(this, arguments);
      };
    }()
  }, {
    key: "finish",
    value: function () {
      var _finish = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all(this.monitors.map(function (monitor) {
                  return monitor.finish();
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function finish() {
        return _finish.apply(this, arguments);
      };
    }()
  }, {
    key: "fail",
    value: function () {
      var _fail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(err) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all(this.monitors.map(function (monitor) {
                  return monitor.fail(err);
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function fail(_x) {
        return _fail.apply(this, arguments);
      };
    }()
  }, {
    key: "cancellable",
    get: function get() {
      // strictly speaking unknown, but let assume it is
      return true;
    }
  }, {
    key: "canceled",
    get: function get() {
      return this.monitors.some(function (monitor) {
        return monitor.canceled;
      });
    }
  }, {
    key: "status",
    get: function get() {
      var statuses = this.monitors.map(function (monitor) {
        return monitor.status;
      });

      if (statuses.every(function (status) {
        return status.tag === 'done';
      })) {
        return {
          tag: 'done',
          total: getStatusesSum(statuses, 'total')
        };
      }

      var failed = statuses.find(function (status) {
        return status.tag === 'failed';
      });

      if (failed) {
        return {
          tag: 'failed',
          total: getStatusesSum(statuses, 'total'),
          error: failed.error
        };
      }

      if (statuses.some(function (status) {
        return status.tag === 'new';
      })) {
        return {
          tag: 'new'
        };
      } // should be every?


      if (statuses.some(function (status) {
        return status.tag === 'canceled';
      })) {
        return {
          tag: 'canceled',
          total: getStatusesSum(statuses, 'total')
        };
      }

      return {
        tag: 'working',
        total: getStatusesSum(statuses, 'total'),
        worked: getStatusesSum(statuses, 'worked'),
        cancelable: statuses.some(function (status) {
          return status.cancelable;
        })
      };
    }
  }]);

  return AggregatedProgressMonitor;
}(ProgressMonitor_1.ProgressMonitor);

exports.AggregatedProgressMonitor = AggregatedProgressMonitor;

function getStatusesSum(statuses, field) {
  return statuses.reduce(function (acc, curr) {
    return acc + (curr[field] || 0);
  }, 0);
}